import React from "react";
import Modal from "../../../../components/Common/Modal/Modal";
import CreateCollection from "../CreateCollection";

const CreateCollectionModal = ({
  isCreateCollectionModal,
  setIsCreateCollectionModal,
}) => {
  return (
    <Modal
      isOpen={isCreateCollectionModal}
      heading={"Create Collection"}
      toggle={() => setIsCreateCollectionModal(false)}
      width={"60"}
    >
      <CreateCollection
        setIsCreateCollectionModal={setIsCreateCollectionModal}
      />
    </Modal>
  );
};

export default CreateCollectionModal;
